import store from '@store/store'

export default class BaseForm {
  static getDataTemplate () {
    throw new Error(
      'static getDataTemplate() must be implemented in the derived class');
  }
  constructor () {
    this.data = this.constructor.getDataTemplate();
    this.params = {};
    this.errors = [];
  }
  clear () {
    this.data = this.constructor.getDataTemplate();
    this.params = {};
    this.errors = [];
  }
  clearError () {
    this.errors = [];
  }
  getGlobalVariables () {
    const globalVariables = store.getters['globalVariables/getClone'];
    if (!globalVariables.initialized) {
      throw new Error('Global variables are not initialized yet.');
    }
    return globalVariables;
  }
  getPostPayload (...args) {
    throw new Error(
      'getPostPayload(...args) must be implemented in the derived class');
  }
  getPutPayload (...args) {
    throw new Error(
      'getPutPayload(...args) must be implemented in the derived class');
  }
  set (data) {
    throw new Error('set(data) must be implemented in the derived class');
  }
}
